import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import Select from "react-select";
import MainSection from "../../components/mainLayout/Main";
import { addSubClient, getAllServices } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

function AddSubClient() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const services = useSelector((state) => state.auth.allServices);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    clientType: "",
    phoneNumber: "",
    opted: [], // Array to store selected services
  });

  useEffect(() => {
    async function func() {
      try {
        const token = localStorage.getItem("token");
        if (token) await dispatch(getAllServices(token));
      } catch (err) {
        console.error(err);
      }
    }
    func();
  }, [dispatch]);

  const handleChange = (e) => {
    if (e.target.id === "phoneNumber") {
      if (e.target.value.length < 11)
        setFormData({ ...formData, [e.target.id]: e.target.value });
    } else {
      setFormData({ ...formData, [e.target.id]: e.target.value });
    }
  };

  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      opted: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(addSubClient(id, formData));
      navigate("/client-management");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const serviceOptions =
    services && services?.map((service) => ({ value: service._id, label: service.name }));

  return (

    <div>
      <Sidebar />

      <MainSection>
        <SectionHeader title="Add Sub-Clients" />

        <div className="conatiner w-full md:w-1/2 lg:w-1/3  text-start">
          <form onSubmit={handleSubmit}>

            <div class="my-5">
              <label
                for="name"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                Client Name
              </label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                placeholder="Enter Client name"
                required
              />
            </div>

            <div class="mb-5">
              <label
                for="email"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                placeholder="Enter email address"
                required
              />
            </div>

            <div className="mb-5">
              <label
                for="clientType"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                Client Type
              </label>
              <select
                id="clientType"
                onChange={handleChange}
                value={formData.clientType}
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
              >
                <option value="" disabled>Select Client type</option>
                <option value="Private Limited">Private Limited</option>
                <option value="Partnership">Partnership</option>
                <option value="Proprietorship">Proprietorship</option>
              </select>
            </div>

            <div class="mb-5">
              <label
                for="phoneNumber"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                Phone Number
              </label>
              <input
                type="number"
                id="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                placeholder="Enter Phone number"
                required
              />
            </div>

            <div className="mb-5">
              <label
                for="services"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                Service
              </label>
              <Select
                id="opted"
                options={serviceOptions}
                isMulti
                onChange={handleSelectChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full"
                placeholder="Select services"
              />
            </div>

            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Create Sub-Client
            </button>
          </form>
        </div>
      </MainSection>
    </div>
  );
}

export default AddSubClient;
